export default __webpack_public_path__ + "static/media/bag9.fc623f23.jfif";